<script setup>

import { computed, onBeforeMount, onMounted } from 'vue';
import PlanCard from '@/components/PlanCard.vue';
import { fetchPlans } from '@/services/plans';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { hasCompanyPlan, hasDemoPlan, useGlobalState } from '@/store/user.store.js';

const emit = defineEmits(['planChosen', 'fetchingDone']);

const props = defineProps(['useCallback']);

const { fetch, response: plans, isLoading: isFetchingPlans } = fetchPlans();
const { userState } = useGlobalState();

const filteredPlans = computed(() => {
  if (!userState.value.isAuthenticated) {
    return plans.value;
  }

  const userHasDemo = hasDemoPlan(userState.value);
  const isCompany = hasCompanyPlan(userState.value);

  return plans.value.filter((plan) => {
    if (isCompany) {
      return plan.planId === 2;
    }
    if (userHasDemo && plan.isDemo) {
      return false;
    }
    return true;
  });
});

onBeforeMount(async () => {
  fetch().then(() => {
    emit('fetchingDone', plans);
  });
});

</script>

<template>
  <div>
    <LoadingSpinner
      class="text-center"
      v-if="isFetchingPlans"
    />

    <div
      v-else
      class="isolate mx-auto mt-12 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4"
    >
      <PlanCard
        :use-callback="props.useCallback"
        @plan-chosen="emit('planChosen', $event)"
        v-for="tier in filteredPlans"
        :key="tier.id"
        :plan="tier"
      />
    </div>
  </div>
</template>
